import { Button, Row } from '@ahmdigital/ui';
import styled from 'styled-components';

export const OptionContainer = styled.div`
  position: relative;

  @media (min-width: ${({ theme }) => theme.media.sm}) {
    height: 100%;
  }
`;

type OptionBoxProps = {
  isHighlighted?: boolean;
};

export const OptionBox = styled.div<OptionBoxProps>`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  height: 100%;
  padding: 1.5rem 2.5rem;
  background-color: ${({ isHighlighted, theme: { colors } }) => (isHighlighted ? colors.purpleTint : colors.grey10)};
  border: 1px solid ${({ isHighlighted, theme: { colors } }) => (isHighlighted ? colors.purple : colors.grey10)};
`;

export const OptionContentRow = styled(Row)`
  flex-direction: column;
`;

export const OptionButton = styled(Button)`
  margin-right: auto;
`;
